import { ShopperAgentConfigStatus as _ShopperAgentConfigStatusEnum } from "@redotech/cockroachdb-codegen/tables/shopper-ai/shopper-agent-config-status";
import * as z from "zod";

type _ShopperAgentConfigStatus = `${_ShopperAgentConfigStatusEnum}`;

/** Wire form of one shopper-agent config version (CRDB ids as strings). */
export const ShopperAgentConfigVersionMetaSchema = z.object({
  versionId: z.string(),
  versionNumber: z.number(),
  status: z.enum(
    Object.values(_ShopperAgentConfigStatusEnum) as [
      _ShopperAgentConfigStatus,
      ..._ShopperAgentConfigStatus[],
    ],
  ),
  enabled: z.boolean(),
  createdById: z.string().optional(),
  publishedAt: z.date().optional(),
  archivedAt: z.date().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ShopperAgentConfigVersionMetaWire = z.infer<
  typeof ShopperAgentConfigVersionMetaSchema
>;
